import {handleResponse} from "@/services/service-helpers.ts"
import {FormerMember} from "@/models/former-member.ts"
import log from '@/lib/logger'

const NBH_FORMER_MEMBERS_BASE_URL = `${import.meta.env.VITE_NBH_URL_ROOT}/api/reports/former-members`

export async function getFormerMembers(
    token: string | null
): Promise<FormerMember[]> {
    if (!token) {
        log.error("No token provided to request former members")
        return Promise.reject("No token provided")
    }

    const response = await fetch(NBH_FORMER_MEMBERS_BASE_URL, {
        method: 'GET',
        headers: new Headers({
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'
        })
    })

    const result = await handleResponse<FormerMember[]>(response)
    return result || []
}
